// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mgl-weekdays-list[data-v-6154453a] {\n  list-style-type: none;\n}\n.mgl-weekdays-list li[data-v-6154453a] {\n  float: left;\n  margin-left: 8px;\n  margin-bottom: 0;\n}\nul[data-v-6154453a] {\n  list-style-type: none;\n  padding: 0;\n}\nul li[data-v-6154453a] {\n  margin-bottom: 5px;\n}", ""]);
// Exports
module.exports = exports;
